/**
 * Remove gid suffix from Google sheet URL
 *
 * @param {string} url Google sheet to remove suffix
 * @returns {string} Google sheet URL with no gid suffix
 */
export const removeGoogleSheetGIDSuffix = (url: string): string => {
  return url.split('#')[0];
};
